/* Töpferkunst Rahmen 2.0 – kleine Helfer für Header, Footer und Land/Sprache. Einmal aus layout/theme.liquid geladen.
   1. Megamenü: mit der Maus öffnen/schließen (Klick + Tastatur macht Dawns details-disclosure.js), Fokus auf den
      Menüpunkt öffnet die Tafel, Escape schließt sie und setzt den Fokus zurück.
   2. Footer-Spalten: Akkordeon unter 750 px (Button in der Überschrift), darüber immer offen.
   3. Land-/Sprachwahl im Footer: <select> ändert sich → Formular absenden (kein Dawn-Disclosure, keine Flaggen). */
(function () {
  'use strict';
  if (window.tkRahmenInit) return;
  window.tkRahmenInit = true;

  /* ── 1. Megamenü ── */
  function initMega() {
    var items = document.querySelectorAll('.tk-nav .tk-nav__item');
    if (!items.length) return;
    var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
    var openTimer = null, closeTimer = null;

    function allDetails() { return document.querySelectorAll('.tk-nav details.tk-mega'); }
    function closeOthers(keep) {
      allDetails().forEach(function (d) {
        if (d !== keep && d.open) {
          d.removeAttribute('open');
          var s = d.querySelector('summary');
          if (s) s.setAttribute('aria-expanded', 'false');
        }
      });
    }
    function open(d) {
      if (!d || d.open) return;
      closeOthers(d);
      d.setAttribute('open', '');
      var s = d.querySelector('summary');
      if (s) s.setAttribute('aria-expanded', 'true');
    }
    function close(d) {
      if (!d || !d.open) return;
      d.removeAttribute('open');
      var s = d.querySelector('summary');
      if (s) s.setAttribute('aria-expanded', 'false');
    }

    items.forEach(function (li) {
      var d = li.querySelector('details.tk-mega');
      if (!d || li.dataset.tkMega) return;
      li.dataset.tkMega = '1';
      var summary = d.querySelector('summary');

      li.addEventListener('mouseenter', function () {
        if (!finePointer.matches) return;
        clearTimeout(closeTimer);
        openTimer = setTimeout(function () { open(d); }, 80);
      });
      li.addEventListener('mouseleave', function () {
        if (!finePointer.matches) return;
        clearTimeout(openTimer);
        closeTimer = setTimeout(function () { close(d); }, 180);
      });
      /* Fokus auf den Menüpunkt öffnet die Tafel (Tastatur); Dawn schließt bei Fokusverlust */
      if (summary) {
        summary.addEventListener('focus', function () { open(d); });
      }
      d.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        e.preventDefault();
        close(d);
        if (summary) summary.focus();
      });
    });
  }

  /* ── 2. Footer-Akkordeon ── */
  function initFooter() {
    var cols = document.querySelectorAll('.tk-footer__col');
    if (!cols.length) return;
    var desktop = window.matchMedia('(min-width: 750px)');
    function sync() {
      cols.forEach(function (col) {
        var btn = col.querySelector('.tk-footer__toggle');
        if (!btn) return;
        if (desktop.matches) {
          btn.setAttribute('aria-expanded', 'true');
          btn.setAttribute('tabindex', '-1');
        } else {
          btn.removeAttribute('tabindex');
          btn.setAttribute('aria-expanded', col.classList.contains('is-open') ? 'true' : 'false');
        }
      });
    }
    cols.forEach(function (col) {
      var btn = col.querySelector('.tk-footer__toggle');
      if (!btn || btn.dataset.tkBound) return;
      btn.dataset.tkBound = '1';
      btn.addEventListener('click', function () {
        if (desktop.matches) return;
        var openNow = col.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', openNow ? 'true' : 'false');
      });
    });
    sync();
    if (desktop.addEventListener) desktop.addEventListener('change', sync);
    else if (desktop.addListener) desktop.addListener(sync);
  }

  /* ── 3. Land/Sprache ── */
  function initLocale() {
    document.querySelectorAll('.tk-locale .tk-locale__select').forEach(function (sel) {
      if (sel.dataset.tkBound) return;
      sel.dataset.tkBound = '1';
      sel.addEventListener('change', function () {
        var form = sel.closest('form');
        if (form) form.submit();
      });
    });
  }

  function boot() { initMega(); initFooter(); initLocale(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  /* Theme-Editor: Abschnitte werden neu gerendert */
  document.addEventListener('shopify:section:load', function () { initFooter(); initLocale(); initMega(); });
})();

/* Rahmen 2.0 – Ankündigungsleiste (Rotation) und Produkt-Tabs */
(function () {
  function ann() {
    document.querySelectorAll('.tk-ann').forEach(function (bar) {
      var msgs = bar.querySelectorAll('.tk-ann__msg'); if (msgs.length < 2 || bar.dataset.tkReady) return; bar.dataset.tkReady = '1';
      var i = 0, iv = (Number(bar.dataset.interval) || 5) * 1000, timer;
      function show(n) { msgs.forEach(function (m, k) { m.classList.toggle('is-active', k === n); }); }
      function start() { timer = setInterval(function () { i = (i + 1) % msgs.length; show(i); }, iv); }
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) { start(); bar.addEventListener('mouseenter', function () { clearInterval(timer); }); bar.addEventListener('mouseleave', start); }
    });
  }
  function tabs() {
    document.querySelectorAll('.tk-pdesc__body[data-tk-tabs="true"]').forEach(function (body) {
      if (body.dataset.tkReady) return;
      var root = body.querySelector('.ba-wrap') || body; var kids = Array.prototype.slice.call(root.children);
      var h2s = kids.filter(function (el) { return el.tagName === 'H2'; }); if (h2s.length < 2) return; body.dataset.tkReady = '1';
      var groups = [], cur = { title: body.dataset.tkTabsFirst || 'Beschreibung', nodes: [] };
      kids.forEach(function (el) { if (el.tagName === 'STYLE' || el.tagName === 'SCRIPT') return; if (el.tagName === 'H2') { if (cur.nodes.length) groups.push(cur); cur = { title: el.textContent.trim().replace(/\s+/g, ' '), nodes: [] }; } cur.nodes.push(el); });
      if (cur.nodes.length) groups.push(cur);
      groups = groups.filter(function (g) { return g.nodes.some(function (n) { return n.textContent.trim(); }); }); if (groups.length < 2) return;
      var wrap = document.createElement('div'); wrap.className = 'tk-tabs'; var list = document.createElement('div'); list.className = 'tk-tabs__list'; list.setAttribute('role', 'tablist'); wrap.appendChild(list);
      groups.forEach(function (g, n) {
        var id = 'tk-tab-' + n; var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'tk-tabs__tab'; btn.id = id + '-btn'; btn.setAttribute('role', 'tab'); btn.setAttribute('aria-controls', id); btn.setAttribute('aria-selected', n === 0 ? 'true' : 'false'); btn.textContent = g.title.length > 38 ? g.title.slice(0, 36) + '…' : g.title; list.appendChild(btn);
        var panel = document.createElement('div'); panel.className = 'tk-tabs__panel' + (n === 0 ? ' is-active' : ''); panel.id = id; panel.setAttribute('role', 'tabpanel'); panel.setAttribute('aria-labelledby', btn.id); g.nodes.forEach(function (node) { panel.appendChild(node); }); wrap.appendChild(panel);
        var acc = document.createElement('button'); acc.type = 'button'; acc.className = 'tk-tabs__acc'; acc.textContent = g.title; acc.setAttribute('aria-expanded', n === 0 ? 'true' : 'false'); wrap.insertBefore(acc, panel);
        function activate() { wrap.querySelectorAll('.tk-tabs__tab').forEach(function (b) { b.setAttribute('aria-selected', 'false'); }); wrap.querySelectorAll('.tk-tabs__panel').forEach(function (p) { p.classList.remove('is-active'); }); wrap.querySelectorAll('.tk-tabs__acc').forEach(function (a) { a.setAttribute('aria-expanded', 'false'); }); btn.setAttribute('aria-selected', 'true'); panel.classList.add('is-active'); acc.setAttribute('aria-expanded', 'true'); }
        btn.addEventListener('click', activate);
        acc.addEventListener('click', function () { if (panel.classList.contains('is-active')) { panel.classList.remove('is-active'); acc.setAttribute('aria-expanded', 'false'); } else activate(); });
      });
      root.appendChild(wrap);
    });
  }
  function boot() { ann(); tabs(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
